class DialogElement extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      showButton: this.querySelector('dialog + button'),
      closeButton: this.querySelector('dialog button'),
      dialog: this.querySelector('dialog'),
    };

    // Ensure dialog element exists
    if (!this.elements.dialog) return;

    // "Show" button opens the dialog
    this.elements?.showButton?.addEventListener('click', () => {
      this.elements.dialog.showModal();
    });

    // "Close" button closes the dialog
    this.elements?.closeButton?.addEventListener('click', () => {
      this.elements.dialog.close();
    });
  }
}
if (!customElements.get('dialog-element')) {
  customElements.define('dialog-element', DialogElement);
}
